module.exports = __webpack_public_path__ + "static/flags/AA-6be82d2cddc10a33829fd6417c05ae34.gif";